import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

export const PaginationItem = styled(NavLink)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  margin: 0 5px;
  font-size: 10px;
  color: ${props => props.theme.grayDarker};

  &.active {
    background-color: ${props => props.theme.brandPrimary};
    border-radius: 2px;
    color: #fff;
  }
`;

export const PaginationControl = styled(NavLink)`
  font-size: 12px;
  color: ${props => props.theme.brandDefault};

  &:first-child {
    margin-right: 10px;
  }

  &:last-child {
    margin-left: 10px;
  }
`;

export const Pagination = styled.div`
  margin: 20px 0;
  text-align: center;
  user-select: none;

  ${props =>
    props.withoutFirstControl &&
    css`
      padding-left: 59px;
    `};

  ${props =>
    props.withoutLastControl &&
    css`
      padding-right: 37px;
    `};
`;
